'use strict';

// key是sys_config_value表中的CONFIG_TYPE
// 對應的CONFIG_VALUE會決定是否要顯示, 0為不顯示1為顯示, 沒有設定視為0
// value必須包在陣列中 用大寫的funCode
// 會直接影響所有被AuthModuleWrapper包起來的Routes以及權限設定的選項

module.exports = Object.freeze({
	'zz.standardCust.am10020': ['ZZ_COMMON_AM10020'],
	'zz.standardCust.am10030': ['ZZ_COMMON_AM10030'],
	'zz.standardCust.pb10040': ['ZZ_COMMON_PB10040', 'ZZ_COMMON_PB10041'],
	'zz.standardCust.ed10010': ['ZZ_COMMON_ED10010'],
});
